export default __webpack_public_path__ + "static/media/available.dbea6e75.svg";